import dynamic from "next/dynamic";
const Layout = dynamic(() => import("../../hoc/staticLayout"), {
  loading: () => <></>,
  ssr: true,
});
const StudentResourcesContent = dynamic(
  () => import("../../components/static/studentResource/resources"),
  { loading: () => <></>, ssr: true }
);
import { withRouter } from "next/router";
import { getStudentResources } from "../../api/student_resources";

function StudentResources(props) {
  const meta = {
    title: "Students resources & services | Bayan",
    description: "Academic resources, campus & student services",
    route: "student-resources",
  };
  return (
    <>
      <Layout theme={props.theme} meta={meta}>
        <StudentResourcesContent
          router={props.router}
          studentResourcesData={props?.studentResourcesData}
        />
      </Layout>
    </>
  );
}
export async function getServerSideProps(ctx) {
  const studentResourcesData = await getStudentResources();
  return { props: { studentResourcesData: studentResourcesData } };
}
export default withRouter(StudentResources);
